import { writable } from "svelte/store";
import { call } from "$lib/Api/Api.svelte";

const gegevensDiensten = writable([]);

const gegevensDienstStore = {
  subscribe: gegevensDiensten.subscribe,
  load: (id) => {
    return call("gegevensDiensten", "query")
      .then((data) => {
        gegevensDiensten.set(data);
      })
      .catch((err) => {});
  },
};

export default gegevensDienstStore;
